import { render, staticRenderFns } from "./GuildRecords.vue?vue&type=template&id=b46fe186"
import script from "./GuildRecords.vue?vue&type=script&lang=js"
export * from "./GuildRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports